import { Claims } from 'src/types/claims';

export interface LoginResponse {
  authorization: string;
  user: IUser;
  succeeded: boolean;
}

export interface IUser {
  userName: string;
  name: string;
  email: string;
  claims: Claims;
  rut: string;
  rol: number;
  lastLogin: Date;
}

export const DefaultIUser = {
  userName: '',
  name: '',
  email: '',
  claims: {} as Claims,
  rut: '',
  rol: 0,
  lastLogin: new Date(),
};

export interface IdentityClaims {
  userName: string;
  name: string;
  picture: string;
  position: string;
  email: string;
  rut: string;
  rol: string;
}

export interface Token {
  token: string;
  expires: Date;
}

export interface IdentityResponse {
  identity: IdentityClaims;
  expired: Date;
}
